import React from 'react';

function Meeting() {
	return (
		<svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M6 14C3.79 14 2 12.21 2 10C2 7.79 3.79 6 6 6C8.21 6 10 7.79 10 10C10 12.21 8.21 14 6 14ZM6 8C4.9 8 4 8.9 4 10C4 11.1 4.9 12 6 12C7.1 12 8 11.1 8 10C8 8.9 7.1 8 6 8Z' fill='#2d2d2d'/>
			<path d='M9 26H3C2.45 26 2 25.55 2 25V18C2 16.35 3.35 15 5 15H7.04C7.96 15 8.81 15.41 9.38 16.12L12.48 19.99L15 20V22H12.49C11.88 22 11.31 21.73 10.92 21.25L7.82 17.38C7.63 17.14 7.34 17 7.04 17H5C4.45 17 4 17.45 4 18V24H8V22H10V25C10 25.55 9.55 26 9 26Z' fill='#2d2d2d'/>
			<path d='M29 26H23C22.45 26 22 25.55 22 25V22H24V24H28V18C28 17.45 27.55 17 27 17H24.96C24.66 17 24.37 17.14 24.18 17.38L21.09 21.25C20.7 21.73 20.13 22 19.51 22H17V20H19.51L22.61 16.13C23.19 15.41 24.05 15 24.96 15H27C28.65 15 30 16.35 30 18V25C30 25.55 29.55 26 29 26Z' fill='#2d2d2d'/>
			<path d='M26 14C23.79 14 22 12.21 22 10C22 7.79 23.79 6 26 6C28.21 6 30 7.79 30 10C30 12.21 28.21 14 26 14ZM26 8C24.9 8 24 8.9 24 10C24 11.1 24.9 12 26 12C27.1 12 28 11.1 28 10C28 8.9 27.1 8 26 8Z' fill='#2d2d2d'/>
			<path d='M21 23H11V25H21V23Z' fill='#2d2d2d'/>
		</svg>
	);
}

export default Meeting;
